export const STANDARD_ALLOCATION_TYPE = 'STANDARD';
export const CUSTOM_ALLOCATION_TYPE = 'CUSTOM';
